<div class=" mt-4">
    <section>
        <div class="row">
            <div class="col-md-10">
                <!-- <div class="float-right">
                    <button class="btn dash-btns mr-3" [routerLink]="['/pos/taxfee/new']">New TaxFee</button>
                    <button class="btn dash-btns" [routerLink]="['/pos/taxfee/manage']">Manage TaxFee</button>
                </div> -->
            </div>
        </div>

    </section>
    <section class="mt-3">
        <div class="">
            <div class="row">
                <div class="col-md-7">
                    <div class="card-1">
                        <div class="row">
                            <div class="col-md-12">
                                <!-- <div class="text-center mb-5">
                                    <img src="assets/img/new/view-trans.svg" />
                                </div> -->
                                <div class="text-center">
                                    <a class="view-h gary-t">View TaxFee</a>
                                </div>
                                <div >
                                    <div class="row mb-3">
                                        <div class="col-4 p-0 label1">TaxFee Name</div>

                                        <div class="col-7 view-text"> {{rows.TaxFeeName}}</div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-4 p-0 label1">taxRate</div>

                                        <div class="col-7 view-text"> {{rows.TaxRate}}</div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-4 p-0 label1">IsDefault</div>

                                        <div class="col-7 view-text">
                                            <input type="checkbox" [(ngModel)]="rows.IsDefault" id="IsDefault"
                                                name="IsDefault" >
                                        </div>
                                    </div>

                                    <div class="row mb-3">
                                        <div class="col-4 p-0 label1">Date Time</div>

                                        <div class="col-7 view-text"> {{rows.DateTime | date:'d/M/yy, h:mm a'}}</div>
                                    </div>




                                </div>
                                <div class="text-right  ">
                                    <button class="btn dash-btns" [routerLink]="['/pos/taxfee/manage']">Back</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="text-center mb-5">
                        <img src="assets/img/new/pos.svg" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>